import angular from "angular";
import _ from "lodash";
import SubEntity from "../core/data/seller/sub-entity.data";
import moment from "moment";

class subentityDetailsCtrl {

    /* @ngInject */
    constructor(
        $uibModal,
        $state,
        $scope,
        AuthSvc,
        logger,
        $translate,
        $filter,
        $window,
        PrincipalSvc,
        SessionSvc,
        RoutingCode,
        RoutingCodeSvc,
        RegistrationSchemesDA
    ) {
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.AuthSvc = AuthSvc;
        this.logger = logger;
        this.$translate = $translate;
        this.$filter = $filter;
        this.$window = $window;
        this.PrincipalSvc = PrincipalSvc;
        this.SessionSvc = SessionSvc;
        this.RoutingCode = RoutingCode;
        this.routingCodeSvc = RoutingCodeSvc;
        this.RegistrationSchemesDA = RegistrationSchemesDA;
        this.DATE_FORMAT_MASK = 'YYYY-MM-DD';
        this.TIME_MASK = {h: 0, m: 0, s: 0, ms: 0};
    }

    $onInit() {
        this.forCreation = this.$state.params.forCreation;
        this.isAuthorisedCPT = this.AuthSvc.isAuthorized('CONFIGURATOR');
        this.isAutorizedToEditSubEntity = !this.isAuthorisedCPT && !this.forCreation;
        this.includes = {
            errorMessages: require('../layouts/error-messages.html')
        };
        if (!this.forCreation) {
            this.$scope.$on('fetchRoutingCodes', function (event, row) {
                this.openRoutingCodeModal(new this.RoutingCode(row), true);
            }.bind(this));
            this.todayDate = moment(this.TIME_MASK).format(this.DATE_FORMAT_MASK);
            this.resetSubEntity = _.cloneDeep(this.subEntity);
            this.subEntityDto = new SubEntity(this.subEntity, this.$translate);

            this.initialSubEntity = new SubEntity(this.subEntity, this.$translate);
            this.status = this.subEntityDto.status;
            this.countryCode = this.subEntityDto.countryCode;
            if (this.countryCode) {
                this.setSubEntityCountry(this.countryCode)
            }
            this.typeLiaison = [
                {code: "RVA"},
                {code: "MAIL"}
            ]
            this.isLiaisonPrincipale = !!this.subEntityDto.diagMainLinkType;
            this.isLiaisonSecondaire = !!this.subEntityDto.diagSecondaryLinkType;
            this.isLiaisonPrincipaleInitial = _.cloneDeep(this.isLiaisonPrincipale);
            this.isLiaisonSecondaireInitial = _.cloneDeep(this.isLiaisonSecondaire);
            this.editDisabled = !this.isEditAuthorized()
            this.hasNotSupportRole = !this.SessionSvc.getCurrentUser().roles.includes('SUPPORT');
            this.statusPpfSend = this.statusPpfSend();

            var defaultCellTemplateUpload =
                '<div class="grid-cell-link text-center"> <div ng-click="grid.appScope.$ctrl.getCgvPdf(row.entity.id)">{{COL_FIELD CUSTOM_FILTERS}}' +
                '<i class="fa fa-download"></i></div></div>';

            var defaultCellTemplateDelete =
                '<div class="grid-cell-link text-center"> <div ng-click="grid.appScope.$ctrl.deleteCgvDoc(row.entity.id)">{{COL_FIELD CUSTOM_FILTERS}}' +
                '<i class="fa fa-trash"></i></div></div>';

            // Tableau CGV
            this.cgvGridOptions = {
                columnDefs: [
                    {
                        name: 'documentVersion',
                        displayName: 'Référence',
                        width: '33%',
                        cellClass: 'justify-content-center',
                    },
                    {
                        name: 'applicationDate',
                        displayName: "Date début d'application",
                        width: '33%',
                        cellClass: 'justify-content-center',
                    },
                    {
                        name: 'documentId',
                        displayName: 'Télécharger',
                        cellTemplate: defaultCellTemplateUpload,
                        width: '28%',
                        cellClass: 'pointer justify-content-center',
                    },
                    {
                        name: 'documentId1',
                        displayName: '',
                        cellTemplate: defaultCellTemplateDelete,
                        width: '6%',
                        cellClass: 'pointer justify-content-center',
                        visible: !this.hasNotSupportRole || !this.editDisabled,
                    },
                ],
                exporterOlderExcelCompatibility: false,
                enableRowSelection: false,
                enableSelectAll: false,
                useExternalPagination: false,
                useExternalSorting: false,
                enableInfiniteScroll: false,
                enableGridMenu: false,
                enableHorizontalScrollbar: 0,
                enableVerticalScrollbar: 0,
                enableSorting: false,
                enableColumnMenus: false,
                onRegisterApi: gridApi => {
                    this.gridApi = gridApi;
                },
                data: this.subEntityCgv,
            };

            if (this.cgvGridOptions.columnDefs[3].visible === false) {
                this.cgvGridOptions.columnDefs[2].width = '34%'
            }
            this.shwoPdpRe = this.canEditPdpRe();

            if (this.shwoPdpRe) {
                this.isDatePdpReChanged = this.datePdpReChanged();
                this.pdpReIsActive = this.isPdpReActive();
                this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe();
                this.isSentoPppf = this.isSentToPpf();
            }
            this.getLegSubEntities(this.subEntityDto.legalEntity.id);
        } else {
            this.initializeSubEntityForCreation();

        }
    }
    statusPpfSend() {
        var status = {};
        if (this.initialSubEntity.pdpRe && this.initialSubEntity.pdpRe.complianceStatus) {
            switch (this.initialSubEntity.pdpRe.complianceStatus) {
                case 'RECEIVING_ADDRESS_PERIOD_ENCLOSES':
                case 'RECEIVING_ADDRESS_PERIOD_EXPIRED':
                case 'RECEIVING_ADDRESS_REQUEST_NOT_FOUND':
                case 'RECEIVING_ADDRESS_ALREADY_EXISTS':
                    status = { color: 'red', text: 'principal.company.not_sent_to_compliance' };
                    break;
                case 'SUCCESS':
                    status = { color: 'orange', text: 'principal.company.in_progress_to_compliance' };
                    break;

            }
        }
        return status;
    }
    getLegSubEntities(legalEntityId) {
        this.PrincipalSvc.getSubEntities(legalEntityId).then((data) => {
            this.legalSubEntities = data;
        });
    }

    initializeSubEntityForCreation() {
        this.subEntityDto = {type: "PRIMARY"};
        this.setSubEntityCountry(this.legalEntity.countryCode)
        this.PrincipalSvc.getSubEntities(this.legalEntity.id).then((data) => {
            this.legalSubEntities = data;
            // Utiliser `some` pour vérifier si un sous-ensemble a le type "PRIMARY"
            const hasPrimary = this.legalSubEntities.some(sub => sub.type === "PRIMARY");

            if (hasPrimary) {
                this.subEntityDto.type = "SECONDARY";
            }

        });
    }

// retourne true si il n'exsiste un etab de type siège social
    headOfficeVerifier() {
        if (this.subEntityDto && this.subEntityDto.headOffice) {
            const hasHeadOffice = this.legalSubEntities.some(sub => sub.headOffice === true && sub.status === "ACTIVE" && (this.subEntityDto.id !== sub.id));
            if (hasHeadOffice) {
                this.logger.error('Le siège social existe déjà');
                return false;
            }
        }
        return true;
    }
    setSubEntityCountry(country) {
        if (country && this.countries) {
            this.subEntityDto.country = _.find(this.countries, { code: country });
        }
    }
    // retourne true si il n'exsiste pas plus d'un etab de type principal
    SubTypeVerifier() {
        if (this.subEntityDto && this.subEntityDto.type === "PRIMARY") {
            const hasPrimary = this.legalSubEntities.some(sub => sub.type === "PRIMARY" && sub.status === "ACTIVE" && (this.subEntityDto.id !== sub.id));
            if (hasPrimary) {
                this.logger.error('L\'établissement principal existe déjà');
                return false;
            }
        }
        return true;
    }

    onChangeCountry(country) {
        if (country) {
            this.checkCodeIsValideIfCountryIsFr(country.code);
        }
    }

    isPdpReActive() {
        let today = moment(this.TIME_MASK)
        if (!this.initialSubEntity.pdpRe || this.initialSubEntity.pdpRe && today.isAfter(this.initialSubEntity.pdpRe.startDate) && !today.isSame(this.initialSubEntity.pdpRe.startDate) && this.initialSubEntity.pdpRe.endDate && today.isAfter(this.initialSubEntity.pdpRe.endDate) && !today.isSame(this.initialSubEntity.pdpRe.endDate)) {
            return false;
        }
        return true;
    }

    // afficher le bloc Pdp réception uniquement en mode édition pour les sous entité dont le pays fait partie de la France métropolitaine et outre-mer
    canEditPdpRe() {
        return this.initialSubEntity.id != null && this.PrincipalSvc.getSocFr().includes(this.subEntityDto.countryCode)
            && this.initialSubEntity.legalEntity.principal.profilBuyer;
    }

    datePdpReChanged() {
        this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe()
        this.isDatePdpReChanged = this.isStartDatePdpReChanged() || this.isEndDatePdpReChanged();
        return this.isDatePdpReChanged;
    }

    isStartDatePdpReChanged() {
        let startDatePdpReChanged = false
        if (this.initialSubEntity.pdpRe && this.initialSubEntity.pdpRe.startDate) {
            let currentStartDate = this.form && this.form.pdpStartDateRe && this.form.pdpStartDateRe.$viewValue ? this.formatDate(this.form.pdpStartDateRe.$viewValue) : moment(this.subEntityDto.pdpRe.startDate)
            startDatePdpReChanged = !this.initialSubEntity.pdpRe.startDate.isSame(currentStartDate);
        } else if (this.form && this.form.pdpStartDateRe && this.form.pdpStartDateRe.$viewValue) {
            startDatePdpReChanged = true
        }
        return startDatePdpReChanged;
    }

    isEndDatePdpReChanged() {
        let EndPdpReChanged = false
        if (this.initialSubEntity.pdpRe && this.initialSubEntity.pdpRe.endDate) {
            let currentEndDate = this.form && this.form.pdpEndDateRe && this.form.pdpEndDateRe.$viewValue ? this.formatDate(this.form.pdpEndDateRe.$viewValue) : moment(this.subEntityDto.pdpRe.endDate)
            EndPdpReChanged = !this.initialSubEntity.pdpRe.endDate.isSame(currentEndDate);
        } else if (this.form && this.form.pdpStartDateRe && this.form.pdpStartDateRe.$viewValue) {
            EndPdpReChanged = true
        }
        return EndPdpReChanged;
    }

    isEditableStartDatePdpRe() {
        let initialStartDate = this.initialSubEntity.pdpRe && this.initialSubEntity.pdpRe.startDate ? moment(this.initialSubEntity.pdpRe.startDate) : null
        let initialEndDate = this.initialSubEntity.pdpRe && this.initialSubEntity.pdpRe.endDate ? moment(this.initialSubEntity.pdpRe.endDate) : null
        if (this.pdpReIsActive) {
            if (!this.initialSubEntity.pdpRe || !this.initialSubEntity.pdpRe.startDate || !this.subEntityDto.pdpRe || !this.subEntityDto.pdpRe.startDate) {
                return true
            } else if (initialStartDate && initialStartDate.isAfter(this.todayDate) && !initialStartDate.isSame(this.todayDate)) {
                return true
            } else if (this.subEntityDto.pdpRe && this.subEntityDto.pdpRe.endDate && initialEndDate && initialEndDate.isBefore(this.todayDate) && !initialEndDate.isSame(this.todayDate)) {
                return true
            }
        }
        return false
    }

    /** transforme une chaine de carac en une date
     *
     * @param dateString
     */
    formatDate(dateString) {
        if (dateString instanceof Date) {
            return moment(dateString);
        } else if (dateString) {
            const dateArray = dateString.replace(/-/g, '/').split('/');
            let formatedDate = new Date(dateArray[2], dateArray[1] - 1, dateArray[0]);
            return moment(formatedDate)
        }
    }

    activeSyPdpRe() {
        // verifie si la date de debut est modifiable
        this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe()
        if (!this.pdpReIsActive) { // verifie l'evenement décocher la case
            if (this.initialSubEntity.pdpRe) {
                if (this.initialSubEntity.pdpRe.startDate.isAfter(this.todayDate) && !this.initialSubEntity.pdpRe.startDate.isSame(this.todayDate)) { // Si une période est déjà enregistrée en base et que période future vider les champs
                    this.clearStartPpdRe()
                    this.clearEndPpdRe()
                } else if (this.initialSubEntity.pdpRe.startDate.isBefore(this.todayDate) && this.initialSubEntity.pdpRe.endDate && this.initialSubEntity.pdpRe.endDate.isBefore(this.todayDate) && !this.initialSubEntity.pdpRe.startDate.isSame(this.todayDate) && !this.initialSubEntity.pdpRe.endDate.isSame(this.todayDate)) { // Si une période est déjà enregistrer en base et que période achevée afficher les valeurs sauvegardées en base
                    this.clearStartPpdRe()
                    this.clearEndPpdRe()
                    this.subEntityDto.pdpRe.startDate = this.initialSubEntity.pdpRe.startDate;
                    this.subEntityDto.pdpRe.endDate = this.initialSubEntity.pdpRe.endDate;
                } else if (this.initialSubEntity.pdpRe.startDate.isBefore(this.todayDate) || this.initialSubEntity.pdpRe.startDate.isSame(this.todayDate)) { // Si une période est déjà enregistrée en base et que période en cours mettre la date du jour au niveau de <Date de fin>
                    this.clearEndPpdRe()
                    this.subEntityDto.pdpRe.endDate = this.todayDate
                }
            } else { // Si aucune période n'est enregistrée en base, vider les champs
                this.clearStartPpdRe()
                this.clearEndPpdRe()
            }
            this.datePdpReChanged()
        }
    }

    minStartReDate() {
        if (this.shwoPdpRe)
            return this.isStartDatePdpReChanged() ? this.todayDate : (this.initialSubEntity.pdpRe && this.initialSubEntity.pdpRe.startDate.isBefore(this.todayDate) ? new Date(this.initialSubEntity.pdpRe.startDate) : this.todayDate)
    }

    maxStartReDate() {
        if (this.shwoPdpRe)
            return this.subEntityDto.pdpRe && this.subEntityDto.pdpRe.endDate ? new Date(this.subEntityDto.pdpRe.endDate) : null;
    }

    minEndReDate() {
        if (this.isEndDatePdpReChanged() && this.subEntityDto.pdpRe && this.subEntityDto.pdpRe.startDate && moment(this.subEntityDto.pdpRe.startDate).isAfter(this.todayDate)) {
            return new Date(this.subEntityDto.pdpRe.startDate)
        } else if (!this.isEndDatePdpReChanged() && this.initialSubEntity.pdpRe && this.initialSubEntity.pdpRe.endDate && !this.initialSubEntity.pdpRe.endDate.isAfter(this.todayDate)) {
            return new Date(this.initialSubEntity.pdpRe.endDate)
        } else {
            return this.todayDate
        }
    }

    clearStartPpdRe() { // vide le champs de date de debut PDP en reception
        this.subEntityDto.pdpRe.startDate = null;
        this.form.pdpStartDateRe.$setValidity('min', true)
        this.form.pdpStartDateRe.$setValidity('date', true)
        this.form.pdpStartDateRe.$setPristine()
    }

    clearEndPpdRe() { // vide le champs de date de fin PDP en reception
        this.subEntityDto.pdpRe.endDate = null;
        this.form.pdpEndDateRe.$setValidity('min', true)
        this.form.pdpEndDateRe.$setValidity('date', true)
        this.form.pdpEndDateRe.$setPristine()
    }

    getGridHeight() {
        var rowHeight = 30;
        return {
            height: this.gridApi.core.getVisibleRows(this.gridApi.grid).length * rowHeight + 30 + 'px',
        };
    }

    //permet d'ouvrir la pop-up pour ajouter un nouveau document cgv
    addNewCGV() {
        this.$uibModal
            .open({
                component: 'modalCgvImportComponent',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    subEntityId: () => this.subEntity.id,
                },
            })
            .closed.then(() => {
            this.PrincipalSvc.getCgvOfSubEntity(this.subEntity.id).then(subEntityCgv => {
                this.cgvGridOptions.data = subEntityCgv;
                this.subEntityCgv = subEntityCgv;
            });
        });
    }

    deleteCgvDoc(documentId) {
        this.PrincipalSvc.deleteCgvDoc(documentId).then(
            data => {
                this.logger.success('CGV supprimé avec succès', data);
                this.PrincipalSvc.getCgvOfSubEntity(this.subEntity.id).then(subEntityCgv => {
                    this.cgvGridOptions.data = subEntityCgv;
                    this.subEntityCgv = subEntityCgv;
                });
            },
            error => {
                this.logger.error('erreur lors de la suppression des cgv', error);
            }
        );
    }

    checkIfEmpty() {
        if (this.subEntityDto.diagMainLinkType === '' || !angular.isDefined(this.subEntityDto.diagMainLinkType)) {
            this.isLiaisonPrincipale = false
            this.liaisonPrincipale();
        }
    }

    liaisonPrincipale() {
        if (!this.isLiaisonPrincipale) {
            this.subEntityDto.diagMainLinkType = null;
            this.subEntityDto.diagMainLinkValue = null;
            this.subEntityDto.diagSecondaryLinkType = null;
            this.subEntityDto.diagSecondaryLinkValue = null;
            this.isLiaisonSecondaire = false;
        }
    }

    liaisonSecondaire() {
        if (!this.isLiaisonSecondaire) {
            this.subEntityDto.diagSecondaryLinkType = null;
            this.subEntityDto.diagSecondaryLinkValue = null;
        }
    }

    emptyLiaisonSecondaire() {
        if (!angular.isDefined(this.subEntityDto.diagMainLinkValue)) {
            this.isLiaisonSecondaire = false
            this.subEntityDto.diagSecondaryLinkType = null;
            this.subEntityDto.diagSecondaryLinkValue = null;
        }
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    back() {
        this.$state.go('app.principal.consult.detailscompanies', {
            legalEntityId: this.legalEntity ? this.legalEntity.id : this.subEntityDto.legalEntity.id
        });
    }

    cancel() {
        if(!this.forCreation){
            this.subEntityDto = _.cloneDeep(this.resetSubEntity);
            this.setSubEntityCountry(this.countryCode)
        }else{
            this.initializeSubEntityForCreation()
        }
        this.isLiaisonPrincipale = _.cloneDeep(this.isLiaisonPrincipaleInitial);
        this.isLiaisonSecondaire = _.cloneDeep(this.isLiaisonSecondaireInitial);
    }

    update() {
        this.setPdpBeforSave();
        const headOfficeIsValide =  this.headOfficeVerifier() ;
        const subTypeIsValide =  this.SubTypeVerifier();
        if (this.form.$valid && headOfficeIsValide && subTypeIsValide) {
            this.prepareDataBeforeSave();
            if (this.countryCode)
                this.subEntityDto.countryCode = this.subEntityDto.country.code
            this.PrincipalSvc.updateSubEntity(this.subEntityDto).then(
                data => {
                    this.logger.success('success.update', data, null, {
                        entityName: "L'établissement",
                    });
                    window.location.reload();

                },
                error => {
                    this._onSaveError(error);
                }
            );
        } else if (this.canShowStartDatePdPReToasterError()) {
            this.logger.error("La date de début de PDP de réception doit être supérieure ou égale à la date du jour")
        } else if (this.canShowEndDatePdPReToasterError()) {
            this.logger.error("La date de fin de PDP de réception doit être supérieure ou égale à la date de début et à la date du jour")
        }
    }

    _onSaveError(error) {
        if (error.status === 400 && error.data) {
            switch (error.data.code) {
                case 'START_DATE_PDP_INVALID':
                    this.logger.error('error.functional.start_date_pdp_invalid');
                    break;
                default:
                    this.logger.error('error.update', error);
                    break;
            }
        }
    }
    create() {
        this.subEntityDto.status = "ACTIVE"
        const headOfficeIsValide =  this.headOfficeVerifier();
        const subTypeIsValide =  this.SubTypeVerifier();
        if (this.forCreation && this.form.$valid && headOfficeIsValide && subTypeIsValide && this.legalEntity && this.legalEntity.id) {
            this.subEntityDto.countryCode = this.subEntityDto.country.code
            this.subEntityDto.legalEntity = this.legalEntity
            this.PrincipalSvc.createSubEntity(this.subEntityDto,this.legalEntity.id).then(
                data => {
                    this.logger.success('success.create', data, null, {
                        entityName: "L'établissement",
                    });
                    this.$state.go('app.principal.consult.details_subentities',{ subEntityId: data.id });
                },
                error => {
                    this.logger.error('error.create', error);
                }
            );
        }
    }

    /**
     * Indique si on doit afficher le toaster d'erreur de la date de debut de reception PDP
     */
    canShowStartDatePdPReToasterError() {
        return (this.datePdpReChanged() && this.subEntityDto.pdpRe.startDate.isBefore(this.todayDate))
    }

    /**
     * Indique si on doit afficher le toaster d'erreur de la date de fin de reception PDP
     */
    canShowEndDatePdPReToasterError() {
        return (this.isEndDatePdpReChanged() || this.isStartDatePdpReChanged()) && this.subEntityDto.pdpRe && this.subEntityDto.pdpRe.endDate && this.subEntityDto.pdpRe.endDate.isBefore(this.subEntityDto.pdpRe.startDate) && !this.subEntityDto.pdpRe.endDate.isSame(this.subEntityDto.pdpRe.startDate);
    }

    setPdpBeforSave() {
        this.setPdpRe();
        if (this.subEntityDto.pdpEm && this.subEntityDto.pdpEm.startDate) {
            this.subEntityDto.pdpEm.startDate = this.formatDate(this.form.pdpStartDateEm.$viewValue);
            this.subEntityDto.pdpEm.endDate = this.subEntityDto.pdpEm.endDate ? this.formatDate(this.form.pdpEndDateEm.$viewValue) : null;
        }
    }

    setPdpRe() {
        if (this.subEntityDto.pdpRe) {
            const startDate = this.form.pdpStartDateRe.$viewValue
                ? this.formatDate(this.form.pdpStartDateRe.$viewValue)
                : null;
            const endDate = this.form.pdpEndDateRe.$viewValue
                ? this.formatDate(this.form.pdpEndDateRe.$viewValue)
                : null;
            if (startDate) {
                this.subEntityDto.pdpRe.startDate = startDate;
                this.subEntityDto.pdpRe.endDate = endDate;
            }
        }
    }

    prepareDataBeforeSave() {
        if (this.subEntityDto.pdpRe && this.subEntityDto.pdpRe.startDate) {
            this.subEntityDto.pdpRe.startDate = this.formatDate(this.form.pdpStartDateRe.$viewValue).format(this.DATE_FORMAT_MASK);
            this.subEntityDto.pdpRe.endDate = this.subEntityDto.pdpRe.endDate ? this.formatDate(this.form.pdpEndDateRe.$viewValue).format(this.DATE_FORMAT_MASK) : null;
        }
        if (this.subEntityDto.pdpEm && this.subEntityDto.pdpEm.startDate) {
            this.subEntityDto.pdpEm.startDate = this.formatDate(this.form.pdpStartDateEm.$viewValue).format(this.DATE_FORMAT_MASK);
            this.subEntityDto.pdpEm.endDate = this.subEntityDto.pdpEm.endDate ? this.formatDate(this.form.pdpEndDateEm.$viewValue).format(this.DATE_FORMAT_MASK) : null;
        }
    }

    // Envoi à la PPF
    isSentToPpf() {
        return this.initialSubEntity.id && (this.initialSubEntity.pdpRe != null && this.initialSubEntity.pdpRe.sentToPpf == true);
    }

    getCgvPdf(documentId) {
        this.PrincipalSvc.getCgvPdf(documentId).then(
            data => {
                this.logger.success('CGV téléchargé avec succès', data);
            },
            error => {
                this.logger.error('Erreur de téléchargement du CGV', error);
            }
        );
    }

    onCodeChange() {
        if(this.subEntityDto.country)
            this.checkCodeIsValideIfCountryIsFr(this.subEntityDto.country.code);

        if (this.checkIfCodeIsAlreadyExist() ){

            this.form.Subcode.$setValidity('subEntitySiretAlreadyExist', false);

        } else {
            this.form.Subcode.$setValidity('subEntitySiretAlreadyExist', true);
            this.form.Subcode.$setPristine();
        }
        if (this.digitRegex(this.subEntityDto.code)) {
            this.form.Subcode.$setValidity('subEntitycodeNotValid', false);

        } else {
            this.form.Subcode.$setValidity('subEntitycodeNotValid', true);
            this.form.Subcode.$setPristine();

        }
    }

    checkIfCodeIsAlreadyExist() {
        return this.legalSubEntities.some(subEntity => subEntity.code === this.subEntityDto.code);
    }

    checkCodeIsValideIfCountryIsFr(country) {
        const isFrance = country === 'FR' && this.legalEntity.countryCode === 'FR';
        const isValidSiret = this.siretConsistentWithFrSiren() && this.LuhnVerifier(this.subEntityDto.code);
        const isSubcodeValid = !isFrance || isValidSiret;

        this.form.Subcode.$setValidity('subEntitySiretNotValid', isSubcodeValid);
        this.form.Subcode.$setPristine(isSubcodeValid);
    }

    siretConsistentWithFrSiren() {
        let match = true;
        if (
            this.legalEntity &&
            this.legalEntity.countryCode === 'FR' &&
            this.legalEntity.idNationalKind.toUpperCase() === 'SIREN' &&
            this.legalEntity.idNational &&
            this.subEntityDto.code
        ) {
            match = this.subEntityDto.code.startsWith(this.legalEntity.idNational.trim());
        }
        return match;
    }

    // SIRET est un numérique à 14 chiffres
    // accept only digits, dashes or spaces
    regexVerifierSubCode(value) {
        return  this.digitRegex(value) || value.length !== 14;
    }

    digitRegex(value) {
        return  /[^0-9-\s]+/.test(value);
    }

    LuhnVerifier(value) {

        if (this.regexVerifierSubCode(value)) {
            return false;
        }

        let nCheck = 0;
        let nDigit = 0;
        let bEven = false;
        let cDigit;
        value = value.replace(/\D/g, '');

        for (let n = value.length - 1; n >= 0; n--) {
            (cDigit = value.charAt(n)), (nDigit = parseInt(cDigit, 10));

            if (bEven) {
                nDigit *= 2;
                if (nDigit > 9) {
                    nDigit -= 9;
                }
            }

            nCheck += nDigit;
            bEven = !bEven;
        }

        return nCheck % 10 === 0;
    }

    openRoutingCodeModal(routingCode, update) {
        this.$uibModal
            .open({
                component: 'routingCode',
                size: 'lg',
                resolve: {
                    update: () => {
                        return update;
                    },
                    principal: () => {
                        return this.initialSubEntity.legalEntity.principal;
                    },
                    legalEntity: () => {
                        return this.initialSubEntity.legalEntity;
                    },
                    subEntity: () => {
                        return this.initialSubEntity;
                    },
                    routingCode: () => {
                        return routingCode;
                    },
                },
            });
    }
}

angular.module('app.principal').component('subentityDetails', {
    templateUrl: require('./subentity-details.html'),
    controller: subentityDetailsCtrl,
    bindings: {
        principal: '<',
        subEntity: '<',
        subEntityCgv: '<',
        forCreation: '<',
        legalEntity: '<',
        countries: '<',

    },
})
